module.exports = __webpack_public_path__ + "img/picture_36.0257b845.png";